import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@digital-hig/typography';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CardCarousel from '../../../common/cardDetails/cardCarousel';
import AffiliationsRootElement from './style';
import { ProfileContextConsumer } from '../../../common/context/profile/context';
import { isItemAvailableInside } from '../../../common/accordionList';

const Affiliations = ({ profileDetails, loading, scrollRef }) => {
  const { affiliations } = profileDetails || {};
  let isValidItems = false;
  if (affiliations) {
    isValidItems = Object.keys(affiliations).map((item) => isItemAvailableInside(item, affiliations)).includes(true);
  }
  const { t } = useTranslation();
  return (
    // eslint-disable-next-line
    <AffiliationsRootElement ref={(el) => (scrollRef.current[1] = el)}>
      {isValidItems && (
        <Box className="page-container">
          <Typography variant="headline-medium" mb={2} component="h3">{t('Affiliations')}</Typography>
          <Typography variant="body-copy-medium" mb={7} className="sub-description">
            {t('Our Partners undergo rigorous evaluations and meet stringent criteria to qualify for the below Affiliations, showcasing their dedication to providing top-tier services and solutions. Discover the Affiliations below to learn more about the distinguished credentials of our Partners.')}
          </Typography>
          <CardCarousel
            loading={loading}
            partners={affiliations}
            hideSliderButtons
            outsideClass="affiliation-image-box"
            pagination={{
              next_page: false,
              total_count: affiliations?.length,
            }}
            cardDescClass="card-desc-fourlines"
            view={false}
            isContentShimmer
          />
        </Box>
      )}
    </AffiliationsRootElement>
  );
};

Affiliations.propTypes = {
  profileDetails: PropTypes.shape({}),
  scrollRef: PropTypes.shape({}),
  loading: PropTypes.bool,
};
Affiliations.defaultProps = {
  scrollRef: {},
  profileDetails: {},
  loading: false,
};

export default ProfileContextConsumer(Affiliations);
